import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { GtmService } from '@df/module-gtm/gtm.service';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { CheckoutFormComponent } from '../../checkout/checkout-form.component';
import { ToggleBlockAbstact } from '../../common/toggle-block.abstract';
import { GiftboxFormComponent } from './giftbox-form.component';

@Component({
    selector: 'giftbox-form-tray',
    templateUrl: './giftbox-form-tray.html',
    standalone: true,
    imports: [CommonModule, GiftboxFormComponent, OffClickDirective, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftboxFormTrayComponent extends ToggleBlockAbstact {
    @Input()
    checkoutFormComponent!: CheckoutFormComponent;

    protected name: string = 'giftboxformtray';

    protected boxId?: number;

    private gtmService = inject(GtmService);

    override show(...args) {
        // store boxId from event so it can be passed to giftbox form if we want to edit existing box
        this.boxId = args[0]?.[0]?.data?.boxId;
        this.sendGtmEvent('openGiftBoxBuilder');
        super.show(...args);
    }

    override hide() {
        if (!this.isVisible) return;
        this.sendGtmEvent('closeGiftBoxBuilder');
        super.hide();
    }

    private sendGtmEvent(event: string): void {
        this.gtmService.push({ event });
    }
}
